export const socialsData = {
    github: 'https://github.com/naeem-noor',
    facebook: 'https://www.facebook.com/maliknaeemnoor',
    linkedIn: 'https://www.linkedin.com/in/naeem-noor/',
    instagram: 'https://www.instagram.com/naeemnoorawan/',
    codepen: '',
    twitter: 'https://twitter.com/naeemnoor22',
    reddit: '',
    blogger: '',
    medium: '',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}